/* eslint-disable */ // my eslint/prettier config from 'et-webclient' is currently incompatible, need to fix later
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useLocation, useParams } from 'react-router-dom'
import { Typography, Steps, notification } from 'antd'
import { FormattedMessage } from 'react-intl'
import axios from 'axios'

import { FlexRow } from '../../FlexboxReusables/FlexItems'
import NotFound from '../../../Routes/PageNotFound'
import { BuyersDetailsForm } from './Steps/BuyersDetailsForm'
import ParticipantsStep from './Steps/ParticipantsStep'
import BuyWithPaypalStep from './Steps/BuyWithPaypalStep'
import SummaryStep from './Steps/SummaryStep'
import { ButtonRow } from './Steps/ButtonRow'
import { BuyersDetails } from './types'
import AnonymousNavbar from '../../Navigation/AnonymousNavbar'
import { SuccessfulPaymentResponse } from '../types'
import { apiUrl, Currencies } from '../../../globals'

const { Step } = Steps

const BuyCourseAccess = () => {
  const location = useLocation()
  const { courseId } = useParams()

  const [course, setCourse] = useState(location.state?.course || null)
  const [isPartner, setIsPartner] = useState(location.state?.isPartner || false)
  const [partnerName, setPartnerName] = useState(location.state?.partnerName || '')
  const [partnerDiscountPercentage, setPartnerDiscountPercentage] = useState(
    location.state?.partnerDiscountPercentage || 0,
  )

  const [numberOfParticipants, setNumberOfParticipants] = useState(0)
  const [currentStep, setCurrentStep] = useState(0)
  const [buyersDetails, setBuyersDetails] = useState<BuyersDetails>({
    companyName: '',
    address: '',
    zipCode: '',
    city: '',
    country: '',
    email: '',
    salutationOfContactPerson: 'Herr',
    contactPerson: '',
    phoneNumber: '',
  })
  const [invoiceCurrency, setInvoiceCurrency] = useState<Currencies>(Currencies.EUR)
  const [paymentDone, setPaymentDone] = useState(false)
  const [successfulPaymentResponse, setSuccessfulPaymentResponse] = useState<SuccessfulPaymentResponse>()

  useEffect(() => {
    if (!course && courseId) {
      axios
        .get(`${apiUrl}/courses/available-for-purchase?courseId=${courseId}`)
        .then((response) => {
          const data = response.data

          if (data.coursePreviews && data.coursePreviews.length > 0) {
            const fetchedCourse = data.coursePreviews[0]
            setCourse(fetchedCourse)
            setIsPartner(data.partnerName !== null)
            setPartnerName(data.partnerName || '')
            setPartnerDiscountPercentage(data.partnerDiscountPercentage || 0)
          }
        })
        .catch(() => {
          notification.error({
            message: 'Fehler',
            description: 'Die Kursdaten konnten nicht geladen werden.',
            placement: 'bottomRight',
          })
        })
    }
  }, [course, courseId])

  if (!course) {
    return <NotFound />
  }

  const goToNextStep = () => {
    setCurrentStep(currentStep + 1)
  }

  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return (
          <BuyersDetailsForm
            buyersDetails={buyersDetails}
            setBuyersDetails={setBuyersDetails}
            invoiceCurrency={invoiceCurrency}
            setInvoiceCurrency={setInvoiceCurrency}
          />
        )
      case 1:
        return (
          <ParticipantsStep
            course={course}
            isPartner={isPartner}
            partnerDiscountPercentage={partnerDiscountPercentage || 0}
            numberOfParticipants={numberOfParticipants}
            setNumberOfParticipants={setNumberOfParticipants}
          />
        )
      case 2:
        return (
          <BuyWithPaypalStep
            course={course}
            isPartner={isPartner}
            partnerName={partnerName}
            buyersDetails={buyersDetails}
            invoiceCurrency={invoiceCurrency}
            numberOfParticipants={numberOfParticipants}
            setPaymentDone={setPaymentDone}
            setSuccessfulPaymentResponse={setSuccessfulPaymentResponse}
            goToNextStep={goToNextStep}
          />
        )
      case 3:
        return <SummaryStep successfulPaymentResponse={successfulPaymentResponse} />
      default:
        return null
    }
  }

  const isCurrentStepValid = () => {
    switch (currentStep) {
      case 0:
        return validateBuyersDetails(buyersDetails)
      case 1:
        return validateNumberOfParticipants(numberOfParticipants)
      case 2:
        return validatePayment(paymentDone)
      case 3:
        return true
      default:
        return false
    }
  }

  const validateBuyersDetails = (details: BuyersDetails) => {
    const requiredFields: (keyof BuyersDetails)[] = [
      'companyName',
      'address',
      'zipCode',
      'country',
      'email',
      'contactPerson',
    ]

    if (details.zipCode && isNaN(Number(details.zipCode))) {
      return false
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (details.email && !emailRegex.test(details.email)) {
      return false
    }

    return requiredFields.every((field) => details[field] && details[field]?.trim() !== '')
  }

  const validateNumberOfParticipants = (numberOfParticipants: number) => numberOfParticipants > 0

  const validatePayment = (paymentDone: boolean) => paymentDone

  return (
    <>
      <AnonymousNavbar />
      <FlexRow margin='1em 0'>
        <Typography.Title level={2}>
          <FormattedMessage id='buyCourseAccess.title' />
        </Typography.Title>
      </FlexRow>
      <StyledSteps current={currentStep}>
        <StyledStep title={<FormattedMessage id='buyCourseAccess.buyersDetails' />} />
        <StyledStep title={<FormattedMessage id='buyCourseAccess.participantCount' />} />
        <StyledStep title={<FormattedMessage id='generic.pay' />} />
        <StyledStep title={<FormattedMessage id='buyCourseAccess.summary' />} />
      </StyledSteps>

      {renderStepContent(currentStep)}

      <ButtonRow currentStep={currentStep} setCurrentStep={setCurrentStep} isCurrentStepValid={isCurrentStepValid} />
    </>
  )
}

export default BuyCourseAccess

const StyledSteps = styled(Steps)`
  margin: 0 auto;
  max-width: 80%;
`

const StyledStep = styled(Step)`
  margin: 1em 0;
`
